import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ForwardButtonComponent} from './forward-button.component';
import {PrimaryButtonComponent} from './primary-button.component';
import {MatButtonModule, MatProgressSpinnerModule} from '@angular/material';

@NgModule({
    imports: [CommonModule, MatButtonModule, MatProgressSpinnerModule],
    exports: [ForwardButtonComponent, PrimaryButtonComponent],
    declarations: [ForwardButtonComponent, PrimaryButtonComponent]
})
export class ButtonModule {
}